console.log("✅ collections-menu-preview.js chargé (version TPE)");



/* ==========================================================================
   YT - Mega menu preview (Méditerranéa -> 3 images fixes)
   File: assets/collections-menu-preview.js
   Dawn compatible - Desktop only
   ========================================================================== */

(() => {
  const DESKTOP_MIN = 990;


    // --- Signature sous le preview ---
const DEFAULT_SIGNATURE = "";

const SIGNATURES = {

  mediterranea: "PU · Caoutchouc naturel · Liège · Microfibre · Accessoires",

  nomade: "PU · Caoutchouc naturel · Microfibre · Accessoires",

  terresdeliege: "Liège · Caoutchouc naturel · Écologique",

  flow: "PU · Caoutchouc naturel · Grip extrême",

  "ginkgos-yin-yang": "PU · Caoutchouc naturel · Grip extrême",
"tapis-de-yoga-antiderapants-pu-caoutchouc-naturel-yoga-pilates-fitness-entrainement-intensif": "PU · Caoutchouc naturel · Grip extrême",


  studioorigin: "TPE · Confort doux · Léger · Débutant(e)s",

  // Waves Evolution (menu) → handle technique paddles
  paddles: "SUP Yoga · Kayak · Aventure · Océan",

  // Gliss Revolution (menu) → handle technique snowboards
  snowboards: "Freestyle · Performance · Design",

  // Pulsar Sélection (menu) → handle technique cardio-fitness
  "cardio-fitness": "Training · Cardio · Accessoires intelligents",

  // Serenity (menu) → handle technique activewear
  activewear: "Activewear · Studio · Mouvement · Serenity",

  lifestyle: "Accessoires femme · Élégance & yoga",
"accessoires-mode-femme-yoga-lifestyle": "Accessoires femme · Élégance & yoga",


  "sensory-soap-atelier": "Savons artisanaux · Sensoriel · Bien-être",
"soins-et-bien-etre": "Savons artisanaux · Sensoriel · Bien-être",

};



  function ensureSignature(preview, previewWrap) {
    if (!preview) return null;

    const host = previewWrap || preview.parentElement;
    if (!host) return null;

    let sig = host.querySelector("[data-yt-preview-signature]");
    if (sig) return sig;

    sig = document.createElement("div");
    sig.className = "yt-preview-signature";
    sig.setAttribute("data-yt-preview-signature", "1");
    sig.textContent = DEFAULT_SIGNATURE;

    // Signature juste après le bloc preview
    preview.insertAdjacentElement("afterend", sig);
    return sig;
  }

  function updateSignature(preview, previewWrap, handle) {
    const sig = ensureSignature(preview, previewWrap);
    if (!sig) return;

    sig.textContent = (handle && SIGNATURES[handle]) ? SIGNATURES[handle] : DEFAULT_SIGNATURE;
  }



 // YT – Mega menu previews (images fixes)

  const PREVIEWS = {


  mediterranea: {
    href: "/collections/mediterranea",
    images: [
      "https://yogaterrae.com/cdn/shop/files/Mediterranea_DolceVita_YogaMat_Product_RUBBER_01_b17d1e36-fdc0-4a81-a68e-374f210a06b4.webp?v=1751044493",
      "https://yogaterrae.com/cdn/shop/files/Mediterranea_SeaShell_YogaMat_Product_RUBBER_01_745fd973-cc30-4c4a-b45b-773dba43bdce.webp?v=1751044195",
      "https://yogaterrae.com/cdn/shop/files/Mediterranea_SunnyDay_YogaMat_Product_BLUE_01.webp?v=1758576415"
    ]
  },

  terresdeliege: {
    href: "/collections/collection-tapis-yoga-liege-caoutchouc-naturel-designs-originaux-terres-de-liege",
    images: [
      "https://yogaterrae.com/cdn/shop/files/Mediterranea_Palmiers_YogaMat_Product_CORK_01_be1fa553-844a-437b-bfaf-572f7cb19a90.webp?v=1751782360",
      "https://yogaterrae.com/cdn/shop/files/YinYang_YogaMat_Product_CORK_01_29bea4a4-eb9d-41cd-9bfa-716298c1fd58.webp?v=1751783691",
      "https://yogaterrae.com/cdn/shop/files/Magnolia_YogaMat_Product_CORK_01_038877e1-a3f2-4007-b956-c6c09510107b.webp?v=1751783557"
    ]
  },

  nomade: {
  href: "/collections/nomade",
  images: [
    "https://cdn.shopify.com/s/files/1/0134/6656/6713/files/Nomade_Montreal_YogaMat_Product_RUBBER_01.webp?v=1758723097",
    "https://cdn.shopify.com/s/files/1/0134/6656/6713/files/Nomade_Kyoto_YogaMat_Product_RUBBER_01.webp?v=1758724811",
    "https://cdn.shopify.com/s/files/1/0134/6656/6713/files/Nomade_Miami_YogaMat_Product_RUBBER_01.webp?v=1767875805"
  ]
},

flow: {
    href: "/collections/flow",
    images: [
      "https://cdn.shopify.com/s/files/1/0134/6656/6713/files/Flow_Green_YogaMat_Product_RUBBER_01_1691a152-80ab-4e46-88f5-04861f593a6b.webp?v=1768313121",
      "https://cdn.shopify.com/s/files/1/0134/6656/6713/files/Flow_Pink_YogaMat_Product_RUBBER_01_8c89f217-c38e-4c8f-aef4-92bdeb47828b.webp?v=1768313147",
      "https://cdn.shopify.com/s/files/1/0134/6656/6713/files/Flow_Purple_YogaMat_Product_RUBBER_01_48ee4ada-a6cb-4bd1-a781-6ed67a8aa37b.webp?v=1768313172"
    ]
  },

studioorigin: {
  href: "/collections/tapis-de-yoga-tpe-antiderapant-confort-doux-leger-debutants",
  images: [
    "https://yogaterrae.com/cdn/shop/files/1_NEW_BORDEAUXCORAIL_d0b958a5-b929-408a-8d06-50eca0a541a7.jpg?v=1697726890",
    "https://cdn.shopify.com/s/files/1/0134/6656/6713/files/1_TPE_ACCESS_VIOLET_CORAIL.webp?v=1777624926",
    "https://cdn.shopify.com/s/files/1/0134/6656/6713/files/1_ACCESS_BEIGE_CORAIL.jpg?v=1721642694"
  ]
},

paddles: {
  href: "/collections/stand-up-paddle-yoga-gonflable-sup-accessoires-pagaie-ailerons-sac-siege-kayak-pompe-leash-securite",
  images: [
    "https://yogaterrae.com/cdn/shop/files/Paddles_Product_GREAT_LAKE_03.webp?v=1750957245",
    "https://yogaterrae.com/cdn/shop/files/Paddles_Product_RED_GLAMOUR_03.webp?v=1750957310",
    "https://yogaterrae.com/cdn/shop/files/Paddles_Product_BLUE_SKY_03.webp?v=1750956621"
   
  ]
},

snowboards: {
  href: "/collections/snowboards-freestyle-femme-homme-design-performance-yogaterrae",
  images: [
    "https://cdn.shopify.com/s/files/1/0134/6656/6713/files/WAVE_SNOWBOARDS_LAKE_TAHOE.webp?v=1770299696",
    "https://cdn.shopify.com/s/files/1/0134/6656/6713/files/WAVE_SNOWBOARDS_GLAMOUR.webp?v=1770299696",
    "https://cdn.shopify.com/s/files/1/0134/6656/6713/files/WAVE_SNOWBOARDS_NAVY_SEALS.webp?v=1770299696"
  ]
},

"cardio-fitness": {
  href: "https://yogaterrae.com/collections/cardio-fitness-accessoires-yoga-training",
  images: [
    "https://yogaterrae.com/cdn/shop/files/JumpRope_Product_BLACK_01_e8cd4ea8-a0d8-4856-8db7-294268370bd3.webp?v=1751802954",
    "https://yogaterrae.com/cdn/shop/files/JumpRope_Product_RED_01_8578a7d5-8342-49c0-b91d-2f8bd14bebac.webp?v=1751802846",
    "https://yogaterrae.com/cdn/shop/files/JumpRope_Product_BLUE_01_551784c5-45e5-43f8-b344-4674f44e5dc3.webp?v=1751802806"
  ]
},

activewear: {
  href: "/collections/activewear-femme-yoga-fitness",
  images: [
     "https://yogaterrae.com/cdn/shop/files/SportBra_Product_BLUE_02.webp?v=1760884776",
    "https://yogaterrae.com/cdn/shop/files/Legging_Product_BLUE_08.webp?v=1752011638",
    "https://yogaterrae.com/cdn/shop/files/Short_Product_BLUE_04.webp?v=1752010476"
  ]
},

lifestyle: {
  href: "/collections/accessoires-mode-femme-yoga-lifestyle",
  images: [
    "https://cdn.shopify.com/s/files/1/0134/6656/6713/files/12_23_Slide_01.webp?v=1766584907"
  ]
},

"accessoires-mode-femme-yoga-lifestyle": {
  href: "/collections/accessoires-mode-femme-yoga-lifestyle",
  images: [
    "https://cdn.shopify.com/s/files/1/0134/6656/6713/files/12_23_Slide_01.webp?v=1766584907"
  ]
},

"sensory-soap-atelier": {
  href: "/collections/soins-et-bien-etre",
  images: [
    "https://yogaterrae.com/cdn/shop/files/S1_LAMER.jpg?v=1698332534",
    "https://yogaterrae.com/cdn/shop/files/S1_VELOURSNOIR.jpg?v=1698332949",
    "https://yogaterrae.com/cdn/shop/files/S1_PLUMERIAPIKAKE.jpg?v=1698333634"
  ]
},

// Fallback texte (si le menu ne fournit pas un handle exploitable)
"soins-et-bien-etre": {
  href: "/collections/soins-et-bien-etre",
  images: [
    "https://yogaterrae.com/cdn/shop/files/S1_LAMER.jpg?v=1698332534",
    "https://yogaterrae.com/cdn/shop/files/S1_VELOURSNOIR.jpg?v=1698332949",
    "https://yogaterrae.com/cdn/shop/files/S1_PLUMERIAPIKAKE.jpg?v=1698333634"
  ]
},

"ginkgos-yin-yang": {
  href: "/collections/tapis-yoga-pu-caoutchouc-naturel-ginkgos-yin-yang",
  images: [
    "https://cdn.shopify.com/s/files/1/0134/6656/6713/files/YinYang_YogaMat_Product_RUBBER_GREEN_MINT_LIGHT_01.webp?v=1751785764",
    "https://cdn.shopify.com/s/files/1/0134/6656/6713/files/Ginko_YogaMat_Product_CORK_01_204fdbd1-9c93-44ac-954f-494baa140185.webp?v=1751783653",
    "https://cdn.shopify.com/s/files/1/0134/6656/6713/files/YinYang_YogaMat_Product_RUBBER_SUNSET_DARK_01_ae4b7d62-da06-496b-a97f-9e581c081892.webp?v=1779001547"
  ]
},

"tapis-de-yoga-antiderapants-pu-caoutchouc-naturel-yoga-pilates-fitness-entrainement-intensif": {
  href: "/collections/tapis-yoga-pu-caoutchouc-naturel-ginkgos-yin-yang",
  images: [
    "https://cdn.shopify.com/s/files/1/0134/6656/6713/files/YinYang_YogaMat_Product_RUBBER_GREEN_MINT_LIGHT_01.webp?v=1751785764",
    "https://cdn.shopify.com/s/files/1/0134/6656/6713/files/Ginko_YogaMat_Product_CORK_01_204fdbd1-9c93-44ac-954f-494baa140185.webp?v=1751783653",
    "https://cdn.shopify.com/s/files/1/0134/6656/6713/files/YinYang_YogaMat_Product_RUBBER_SUNSET_DARK_01_ae4b7d62-da06-496b-a97f-9e581c081892.webp?v=1779001547"
  ]
},


};

 // Préchargement léger (safe - sans optional chaining)
Object.values(PREVIEWS).forEach((item) => {
  const imgs = (item && item.images) ? item.images : [];
  imgs.forEach((src) => {
    const img = new Image();
    img.decoding = "async";
    img.loading = "eager";
    img.src = src;
  });
});


  const norm = (s = "") =>
  String(s)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // accents
    .replace(/[-\s]/g, "")           // tirets + espaces
    .trim();

    // Map de clés normalisées => clé réelle dans PREVIEWS
const PREVIEWS_KEYMAP = Object.create(null);
Object.keys(PREVIEWS).forEach((k) => {
  PREVIEWS_KEYMAP[norm(k)] = k;
});


  function findRoot() {
    return document.querySelector(".yt-collections-dropdown");
  }

  function findPreview(root) {
    if (!root) return null;
    return (
      root.querySelector(".yt-collections-dropdown__preview-inner") ||
      root.querySelector(".yt-collections-dropdown__preview") ||
      null
    );
  }

  function findList(root) {
    if (!root) return null;
    return root.querySelector(".yt-collections-dropdown__list") || root.querySelector("ul") || null;
  }

  function ensurePreviewStyles(preview) {
    if (!preview) return;

    preview.style.display = "block";
    preview.style.width = "100%";
    preview.style.minHeight = "0";
preview.style.height = "auto";

    preview.style.maxHeight = "none";
    preview.style.borderRadius = "14px";
    preview.style.overflow = "hidden";
    preview.style.visibility = "visible";
    preview.style.opacity = "1";

    // nettoyage d’anciens backgrounds
    preview.style.backgroundImage = "";
    preview.style.backgroundSize = "";
    preview.style.backgroundPosition = "";
    preview.style.backgroundRepeat = "";
  }

  function clearPreview(preview) {
  if (!preview) return;
  preview.innerHTML = `
  <div class="yt-collections-placeholder">
    <div class="yt-collections-placeholder-inner">
      <strong>Bienvenue dans l’univers de création Yogaterrae</strong>
      <span>En quelques secondes, visualisez l’ensemble des collections créées pour vous</span>
    </div>
  </div>
`;

// ✅ Au repos : on redonne de la hauteur au placeholder "Bienvenue…"
preview.style.minHeight = "520px";
preview.style.height = "auto";


  delete preview.dataset.ytPreviewActive;
}


  function renderFixedGrid(preview, images, handle) {
  if (!preview) return;

  ensurePreviewStyles(preview);

// ✅ En hover : on enlève la hauteur du placeholder
preview.style.minHeight = "0";
preview.style.height = "auto";



  preview.innerHTML = `
  <div style="
  display:grid;
  grid-template-columns:repeat(3, 1fr);
  gap:16px;
  padding:24px 16px 16px;

  box-sizing:border-box;
">

    ${images.map(src => `
      <div style="border-radius:14px; overflow:hidden;">
        <img
  class="yt-preview-img"
  src="${src}"
  alt=""
  loading="lazy"
  decoding="async"
  style="
    width:100%;
    height:100%;
    object-fit:contain;
    display:block;
    ${handle === 'snowboards' ? 'transform:scale(1);' : ''}
  "
/>

      </div>
    `).join("")}
  </div>
`;

// Fade-in images (grid)
requestAnimationFrame(() => {
  preview.querySelectorAll('.yt-preview-img').forEach((img) => {
    img.classList.add('is-visible');
  });
});



  preview.dataset.ytPreviewActive = handle;
  preview.dataset.ytPreviewHref = PREVIEWS[handle]?.href || "";
}

// Renderer spécifique pour previews mono-image (Lifestyle, Paddles, etc.)

function renderPaddlesHero(preview, src, href) {
  if (!preview) return;


  ensurePreviewStyles(preview);

  preview.innerHTML = `
    <a href="${href || "#"}" style="display:block; padding:16px;">
      <div style="
        border-radius:14px;
        overflow:hidden;
        width:100%;
        aspect-ratio:16 / 9;
        background:#fff;
      ">
        <img
  class="yt-preview-img"
  src="${src}"
  alt=""
  loading="lazy"
  decoding="async"
  style="
    width:100%;
    height:100%;
    display:block;
    object-fit:contain;
    object-position:center center;
    transform-origin:center center;
    transform:scale(1);
  "
/>

      </div>
    </a>
  `;
}

// Fade-in image (hero)
requestAnimationFrame(() => {
  preview.querySelectorAll(".yt-preview-img").forEach((img) => {
    img.classList.add("is-visible");
  });
});


  function getHandleFromEventTarget(el) {
  const a = el.closest("a, summary");

  if (!a) return null;

 
  

  // 0) Shopify met parfois l'URL réelle dans data-href
  const rawHref =
    a.getAttribute("data-href") ||
    a.dataset.href ||
    a.getAttribute("href") ||
    "";

  const hrefLower = String(rawHref).toLowerCase();

  // 🎯 Fallback explicite pour le menu Lifestyle (lien parent Dawn non fiable)
if ((a.textContent || "").toLowerCase().includes("lifestyle")) {
  return "accessoires-mode-femme-yoga-lifestyle";
}


  // ✅ Mapping robuste : si l'URL contient le handle attendu (même si URL longue)
  if (hrefLower.includes("mediterranea")) return "mediterranea";
  if (hrefLower.includes("terres-de-liege")) return "terresdeliege";
  if (hrefLower.includes("tapis-de-yoga-tpe-antiderapant")) return "studioorigin";
  if (hrefLower.includes("stand-up-paddle-yoga-gonflable")) return "paddles";
  if (hrefLower.includes("snowboards-freestyle")) return "snowboards";
  if (hrefLower.includes("cardio-fitness")) return "cardio-fitness";
  if (hrefLower.includes("activewear-femme-yoga-fitness")) return "activewear";
  if (hrefLower.includes("accessoires-mode-femme-yoga-lifestyle")) return "lifestyle";


/// 1) data-yt-collection-handle (si present)
const dataHandle =
  a.getAttribute("data-yt-collection-handle") ||
  a.closest("li")?.getAttribute("data-yt-collection-handle");

if (dataHandle) {
  const raw = String(dataHandle).trim();
  if (PREVIEWS[raw]) return raw;

  const k = norm(raw);
  if (PREVIEWS[k]) return k;
}


 // 2) Extraire depuis /collections/xxxxx
const m = String(rawHref).match(/\/collections\/([^\/?#]+)/i);
if (m) {
  const raw = m[1];
  if (PREVIEWS[raw]) return raw;

  const k = norm(raw);
  if (PREVIEWS[k]) return k;
}


  // 3) Paramètre ?handle=
try {
  const url = new URL(rawHref, window.location.origin);
  const handleParam = url.searchParams.get("handle");
  if (handleParam) {
    const raw = String(handleParam).trim();
    if (PREVIEWS[raw]) return raw;

    const k = norm(raw);
    if (PREVIEWS[k]) return k;
  }
} catch (e) {}


  // 4) Dernier recours : texte du lien
  const txt = norm(a.textContent || "");
  if (PREVIEWS[txt]) return txt;

  return null;
}

  function wireOnce(root) {
    if (!root || root.dataset.ytWired === "1") return;
    root.dataset.ytWired = "1";

    const preview = findPreview(root);
const list = findList(root);


if (!preview || !list) {
  console.warn("[YT] wireOnce: preview ou list introuvable", { preview, list, root });
  return;
}

const previewWrap = root.querySelector(".yt-collections-dropdown__preview");


// Signature : création + affichage par défaut
ensureSignature(preview, previewWrap);
updateSignature(preview, previewWrap);



// Rendre le preview cliquable quand Méditerranée est active
if (preview) {
  preview.addEventListener("click", () => {
    const href = preview.dataset.ytPreviewHref;
    if (href) window.location.href = href;
  });
}

if (!preview || !list) return;


    ensurePreviewStyles(preview);
    clearPreview(preview);

  list.addEventListener("mouseover", (e) => {
  // Retire l'état actif précédent
  const prevActive = list.querySelector(".yt-collections-dropdown__item--active");
  if (prevActive) prevActive.classList.remove("yt-collections-dropdown__item--active");

  const a = e.target.closest("a");
if (!a) return;


const li = a.closest("li");
if (!li) return;

// ✅ Dégrisage pour TOUS les items (tu laisses ton code ici)
li.classList.add("yt-collections-dropdown__item--active");

const rawHandle = getHandleFromEventTarget(a);
const handle = PREVIEWS_KEYMAP[norm(rawHandle)] || norm(rawHandle);


if (handle && PREVIEWS[handle]) {

  updateSignature(preview, previewWrap, handle);

  const imgs = PREVIEWS[handle].images || [];


  if (
  (handle === "paddles" || handle === "lifestyle" || handle === "accessoires-mode-femme-yoga-lifestyle")
  && imgs.length === 1
) {
  renderPaddlesHero(preview, imgs[0], PREVIEWS[handle].href);
} else {
  renderFixedGrid(preview, imgs, handle);
}

} else {
  clearPreview(preview);
  updateSignature(preview, previewWrap);
}


});


   root.addEventListener("mouseleave", () => {
  const prev = list.querySelector(".yt-collections-dropdown__item--active");
  if (prev) prev.classList.remove("yt-collections-dropdown__item--active");
  clearPreview(preview);

  updateSignature(preview, previewWrap);

});

  }

  function init() {
    const root = findRoot();
    if (root) wireOnce(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  const obs = new MutationObserver(init);
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();





